const logLevels = ['ALL', 'INFO', 'WARN', 'ERROR', 'SILENT'];
export class Logger {
  constructor(logLevel = 'WARN') {
    this.logLevel = logLevel;
  }

  log(logLevel, name, message, params) {
    if (logLevels.indexOf(logLevel) < logLevels.indexOf(this.logLevel)) {
      return;
    }

    const colors = (() => {
      switch (logLevel) {
        case 'INFO':
          return {
            backgroundColor: '#e3fafc',
            color: '#0b7285'
          };

        case 'WARN':
          return {
            backgroundColor: '#fff4e6',
            color: '#d9480f'
          };

        case 'ERROR':
          return {
            backgroundColor: '#fff5f5',
            color: '#c92a2a'
          };
      }
    })();

    const tag = (() => {
      switch (logLevel) {
        case 'INFO':
          return '정보';

        case 'WARN':
          return '경고';

        case 'ERROR':
          return '오류';
      }
    })();

    console.log(`%c${tag}` + `%c${name}` + `%c\n${message}`, `
        background-color: ${colors.color};
        color: ${colors.backgroundColor};
        border-top-left-radius: .1875rem;
        border-bottom-left-radius: .1875rem;
        padding: .125rem .25rem;
        margin-bottom: .125rem;
      `, `
        background-color: ${colors.backgroundColor};
        color: ${colors.color};
        border-top-right-radius: .1875rem;
        border-bottom-right-radius: .1875rem;
        padding: .125rem .25rem;
        margin-bottom: .125rem;
      `, ``, ...(params ? [params] : []));
  }

}